/* unplugin-vue-components disabled */import { render } from "./AuthItemList.vue?vue&type=template&id=dcd2e0ec&scoped=true&ts=true"
import script from "./AuthItemList.vue?vue&type=script&lang=ts"
export * from "./AuthItemList.vue?vue&type=script&lang=ts"

import "./AuthItemList.vue?vue&type=style&index=0&id=dcd2e0ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcd2e0ec"]])

export default __exports__